import { render, staticRenderFns } from "./cleaningResources.vue?vue&type=template&id=3044908a&"
import script from "./cleaningResources.vue?vue&type=script&lang=js&"
export * from "./cleaningResources.vue?vue&type=script&lang=js&"
import style0 from "./cleaningResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports